import React from 'react'
import { NavLink } from 'react-router-dom'

const Navigation = ({navigation, classNames, setSidebarOpen = null}) => {
  const loggedInUser = JSON.parse(localStorage.getItem('userDetails'))

  return (
    <ul className="-mx-2 space-y-1">
    {
      navigation.map((item) => {
        if(item.permissionRole.includes(loggedInUser.accountType)) {
          return (
            <li key={item.name} onClick={() => setSidebarOpen && setSidebarOpen(false)}>
              <NavLink
                to={item.href}
                className={({ isActive }) =>
                  classNames(
                    isActive ? 'bg-gray-50 text-indigo-600' : 'text-gray-700 hover:bg-gray-50 hover:text-indigo-600',
                    'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold'
                  )
                }
              >
                {({ isActive }) => (
                  <>
                    <item.icon
                      aria-hidden="true"
                      className={classNames(
                        isActive ? 'text-indigo-600' : 'text-gray-400 group-hover:text-indigo-600',
                        'size-6 shrink-0'
                      )}
                    />
                    {item.name}
                  </>
                )}
              </NavLink>
            </li>
          )
        }
      })
    }
  </ul>
  )
}

export default Navigation